import { Component, NgModule, Input, OnInit, Output, EventEmitter, OnDestroy, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormGroup, Validators, ReactiveFormsModule, FormArray, } from '@angular/forms';
import { LookupService } from '../../../services/lookup.service';
import { BaseFormComponent } from '../../../models/base/base-form.component';
import { SimpleControlModule } from './dynamic/simple-control.component';
import { FormHelperService } from '../../../services/form-helper.service';
import { SharedService } from '../../../services/shared.service';
import { UserService } from '../../../services/user.service';
import { ConfirmDeleteDialogModule } from './confirm-delete-dialog.component';
import { DynamicControlErrorModule } from './dynamic/dynamic-control-error.component';

@Component({
  selector: 'driver-truck-form',
  templateUrl: './driver-truck-overhual-form.componet.html',
  providers: [LookupService]
})
export class DriverTruckOberhualFormComponent extends BaseFormComponent implements OnInit {

  @Input() declare form: FormGroup;
  @Input() maxDateRange: number = 10;
  @Input() noOfRequireDateFields = 1;
  @Input() formKey: string = 'orderDriverDetail';
  @Input() type: string;
  @Input() isDispatched : boolean = false;
  @Input() carrierData ;
  @Input() orderStatus: number = 0; 
  @Output() noActiveDriverFlagChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() policyData: EventEmitter<any> = new EventEmitter<any>();
  public lookups: any = {};
  carrierStatus:number;

  dynamicDateFormArray: FormArray = null;

  showDeleteWarning: boolean = false;
  deleteIndex: number | null = null;

  constructor(private lookupService: LookupService, private fh: FormHelperService, private sharedService: SharedService , private userService: UserService) {
    super();
  }

  ngOnInit() {
    this.loadLookup('truckHash');
    this.loadLookup('driverType');
    this.dynamicDateFormArray = this.form.get(this.formKey) as FormArray;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["carrierData"]) {
      const currentValue = changes["carrierData"].currentValue;
      if (currentValue) {
        this.carrierStatus = currentValue.carrierStatus;
        this.userService
          .getCarrierDrivers(currentValue.value)
          .subscribe((response) => {
            this.policyData.emit(response.body);
            const drivers =
              response.body?.driverPhonesDetails.map((item) => ({
                label: `${item.firstName} ${item.lastName}`,
                value: item.id,
                phoneNumbers: item.phoneNumbers,
                disabled: false,
              })) || [];

            this.lookups["carriersDriver"] = drivers;

            if (drivers.length > 0) {
              this.updateCarrierDriverList();

              this.sendHasNoActiveDriverWarning(
                drivers.length > 0
              );
            } else {
              this.sendHasNoActiveDriverWarning(this.carrierStatus == 1);
            }
          });
      } else {
        this.lookups["carriersDriver"] = [];
      }
    }
  }

  get canAddMoreDate(): boolean {
    return this.dynamicDateFormArray?.length < this.maxDateRange;
  }


  add() {
    if (this.canAddMoreDate) {
      const newDriverForm = this.fh.getDriverTruckOverhualForm(null, this.carrierStatus);
      this.dynamicDateFormArray.push(newDriverForm);
      newDriverForm.markAllAsTouched();
      newDriverForm.updateValueAndValidity();
    }
  }

  remove(i: number) {
    this.dynamicDateFormArray.removeAt(i);
    this.updateCarrierDriverList();
  }

  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  onCarrierDriverSelect(index: number, event: any): void {
      const foundCarrier = this.lookups["carriersDriver"].find((x) => x.value == event);
      const formGroup = this.dynamicDateFormArray.at(index) as FormGroup;
      foundCarrier.disabled = true;
      formGroup.get('driverPhone')?.setValue(foundCarrier?.phoneNumbers);
      formGroup.get('driverPhone').updateValueAndValidity();
      formGroup.get('driverName')?.setValue(foundCarrier?.label);
      formGroup.get('driverName').updateValueAndValidity();
      this.updateCarrierDriverList()
  }

  onDriverTypeChange(index: number, event: any): void {
   const formGroup = this.dynamicDateFormArray.at(index) as FormGroup;

   const driverNameControl = formGroup.get("driverName");
   const driverPhoneControl = formGroup.get("driverPhone");

   const isCarrierPremitive = this.carrierStatus === 1;
   const isTBD = event === "TBD";

   let driverPhoneValidators = [];

   if (isCarrierPremitive) {
     driverPhoneValidators = [
       ...(isTBD ? [] : [Validators.required]),
       Validators.minLength(10),
       Validators.maxLength(18),
     ];
   }

   driverNameControl?.setValidators(isTBD ? [] : [Validators.required]);
   driverPhoneControl?.setValidators(driverPhoneValidators);
   
   driverNameControl?.updateValueAndValidity();
   driverPhoneControl?.updateValueAndValidity();
  }

  updateCarrierDriverList(){
    this.lookups["carriersDriver"] =  this.lookups["carriersDriver"].map((option) => {
      const isSelected = this.dynamicDateFormArray.value.some(
        (selected) => selected.driverId === option.value
      );
      return { ...option, disabled: isSelected };
    });
  }

  validateCarrierDriverId(id){
    if (this.lookups["carriersDriver"]) {
      return id === 0 || id == null;
    }
  }

  sendHasNoActiveDriverWarning(value: boolean): void {
    this.noActiveDriverFlagChange.emit(value);
  }

  onDeleteConfirm(result: boolean) {
    if (result && this.deleteIndex !== null) {
      this.remove(this.deleteIndex);
    }
    this.showDeleteWarning = false;
    this.deleteIndex = null;
  }

  confirmDelete(i: number) {
    this.deleteIndex = i;
    this.showDeleteWarning = true;
  }
}



@NgModule({
  declarations: [
    DriverTruckOberhualFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SimpleControlModule,
    ConfirmDeleteDialogModule,
    DynamicControlErrorModule
  ],
  exports: [
    DriverTruckOberhualFormComponent
  ]
})
export class DriverTruckOverhualFormModule { }
